import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { TYPE_PROFILE } from "../../../constants/page-types";
import { useEventContext } from "../../../context/EventContext";
import { useLocaleContext } from "../../../context/LocaleContext";
import { useUserContext } from "../../../context/UserContext";
import { UserAvatar } from "../../User";
import { CButton, CDropDown } from "../../UI";
import "./style.scss";

export const getUserNickname = (user, event) => {
    if (!user) {
        return '';
    }

    if (user.nickname) {
        return user.nickname;
    }

    if (user.info?.nickname) {
        return user.info.nickname;
    }

    const format = event?.moduleAuth?.nicknameFormat || '{surname} {name} {patronymic}';

    return format
        .replace(/{([-_\w]+)}/gi, function(m, name) {
            let value = '';
            if(user[name]) {
                value = user[name];
            } else if(user.info && user.info[name]) {
                value = user.info[name];
            }
            return value;
        })
        .trim() || ('Зритель #' + user.id);
}

export const UserMenuIcon = () => {
    const { event, watchKey, pages } = useEventContext();
    const { get } = useLocaleContext();
    const { user, logout, participationType, setParticipationType } = useUserContext();
    const [menuVisible, setMenuVisible] = useState(false);

    const isProfileVisible = pages.find(({ type }) => type === TYPE_PROFILE)?.visible || false;

    const handleMenuVisibleToggle = async () => {
        setMenuVisible(!menuVisible)
    };

    return (
        <div>
            <CDropDown
                trigger={
                    <UserAvatar
                        user={user}
                        onClick={handleMenuVisibleToggle}
                    />
                }
                maxWidth={320}
                isClosed={!menuVisible}
                className="user-menu-dropdown"
            >
                <div className={"user-menu"}>
                    {/* <select value={participationType} onChange={(e) => setParticipationType(e.target.value)}>
                        <option value="online">Online</option>
                        <option value="offline">Offline</option>
                    </select> */}

                    <div className="user-menu__details">
                        <p className="user-menu__details-name">
                            {getUserNickname(user, event)}
                        </p>
                        <p className="user-menu__details-email">
                            {user.email}
                        </p>
                    </div>
                    {isProfileVisible && (
                        <div className="user-menu__actions">
                            <NavLink
                                to={`/event/${watchKey}/profile`}
                                className="user-menu__actions-link"
                                onClick={() => setMenuVisible(false)}
                            >
                                {get('user.profile.goToProfile')}
                            </NavLink>
                        </div>
                    )}
                    <CButton
                        label={get('auth.logout')}
                        size="lg"
                        onClick={logout}
                    />
                </div>
            </CDropDown>
        </div>
    );
}
